import React from "react";
import { Eye, ShieldCheck, SquarePen } from "lucide-react";
import { twMerge } from "tailwind-merge";

type IPriceCard = {
  amount: number;
  submitDate: string;
  role: string;
  payment_link?: string | null;
  onView?: () => void;
  onEdit?: () => void;
  // onDelete?: () => void;
  isLatest?: boolean;
  isAgreed?: boolean | number;
  status: string;
  agreed_admin_confirm_date?: Date | null;
};

export const PriceCard: React.FC<IPriceCard> = ({
  amount,
  submitDate,
  role,
  payment_link,
  onView,
  onEdit,
  // onDelete,
  isLatest = false,
  isAgreed = false,
  status,
  agreed_admin_confirm_date,
}) => {
  const isPriceAgreed = isAgreed === true || isAgreed === 1;

  return (
    <div
      className={twMerge(
        "group relative rounded-lg bg-white transition-colors border-1 group",
        isPriceAgreed
          ? " border-primary-500 bg-primary-50/20"
          : " border-gray-200",
        status === "failed" ? " border-red-500 bg-red-50/20" : "",
        isPriceAgreed && status !== "failed"
          ? "border-primary-300 bg-primary-50/30"
          : "inert",

        status === "failed" ? "border-red-500 bg-red-50/30" : "",
        agreed_admin_confirm_date !== null &&
          status !== "failed" &&
          "border-primary-500 bg-primary-50/30",
      )}
    >
      {/* Date as legend - top left corner */}
      <div
        className={twMerge(
          "absolute -top-2 left-4 bg-white px-2 text-[10px] font-medium border-1 rounded-full flex items-center gap-1",
          isPriceAgreed
            ? "border-primary-500 text-primary-600 font-semibold"
            : "border-gray-200",
          status === "failed" ? " border-red-500 bg-white text-red-500" : "",
        )}
      >
        {submitDate}{" "}
        {isLatest && (
          <span className="relative flex items-center justify-center h-3 w-3">
            {/* Pulsing background */}
            <span className="absolute inset-0 rounded-full bg-primary-300 animate-ping" />
            {/* Static foreground */}
            <span className="relative h-2 w-2 rounded-full bg-primary-500" />
          </span>
        )}
      </div>

      {/* Admin Shield */}
      {role === "1" && (
        <div className="absolute -top-2 right-4 bg-white">
          <ShieldCheck className="size-4 text-amber-500" />
        </div>
      )}

      {/* Card Content */}
      <div className="flex items-center justify-between p-4 ">
        {/* Amount */}
        <span className="text-base font-semibold text-gray-800">
          ₦{amount.toLocaleString()}{" "}
          {isPriceAgreed &&
            agreed_admin_confirm_date !== null &&
            status !== "failed" &&
            "🤝"}
        </span>

        {/* Right section - Role & Actions */}
        <div className="flex items-center gap-1">
          {payment_link && (
            <button
              onClick={onView}
              className={twMerge(
                "rounded-md p-1.5 text-gray-500 transition-colors bg-gray-100/30 hidden group-hover:block",
              )}
              aria-label="View"
            >
              <Eye size={14} />
            </button>
          )}
          <button
            onClick={onEdit}
            className="rounded-md p-1.5 text-gray-500 transition-colors bg-gray-100/30"
            aria-label="Edit"
          >
            <SquarePen size={14} />
          </button>
          {/* <button
              onClick={onDelete}
              className="rounded-md p-1.5 text-red-500 transition-colors bg-red-50/30"
              aria-label="Delete"
            >
              <Trash2 size={14} />
            </button> */}
        </div>
      </div>
    </div>
  );
};
